import { authHeader } from '@/helpers';
import { handleResponse } from './base.service';

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/api/EmailTemplates`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      return response.data;
    });
}

function getById(id: any) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/api/EmailTemplates/${id}`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      return response.data;
    });
}

function create(template: any) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(template)
  };

  return fetch(`/api/EmailTemplates`, requestOptions as any).then(handleResponse);
}

function update(id: number, template: any) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(template)
  };

  return fetch(`/api/EmailTemplates/${id}`, requestOptions as any).then(handleResponse);
}

function deleteTemplate(id: number) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`/api/EmailTemplates/${id}`, requestOptions as any).then(handleResponse);
}

export const templateService = {
  getAll,
  getById,
  create,
  update,
  deleteTemplate
};
